export const stripEmojis = (value: string) => {
  const regex = /[^\p{L}\p{N}\p{P}\p{Z}^=$\n]/gu;

  return {
    count: value?.match(regex)?.length ?? 0,
    value: value?.replace(regex, '') ?? ''
  };
};
